import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const payRateTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    position_type: z.string(),
    avg_pay_rate: z.number(),
  })
)

export type PayRateTimeseries = z.infer<typeof payRateTimeseriesResponse>

export async function getPayRateTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/pay_rate_timeseries', data, { signal })
    .then((response) => response.data)
    .then(payRateTimeseriesResponse.parse)
}

export async function getPayRateTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/pay_rate_timeseries/csv', data, { signal })
    .then((response) => response.data)
}
